import { translate } from "app/language/service"

export const getMapboxLocale = (): { [key: string]: string } => {
  return {
    "AttributionControl.ToggleAttribution": translate("mapbbox.attribution-control.toggle-attribution"),
    "AttributionControl.MapFeedback": translate("mapbbox.attribution-control.map-feedback"),
    "FullscreenControl.Enter": translate("mapbbox.fullscreen-control.enter"),
    "FullscreenControl.Exit": translate("mapbbox.fullscreen-control.exit"),
    "GeolocateControl.FindMyLocation": translate("mapbbox.geolocate-control.find-my-location"),
    "GeolocateControl.LocationNotAvailable": translate("mapbbox.geolocate-control.location-not-available"),
    "LogoControl.Title": translate("mapbbox.logo-control.title"),
    "Map.Title": translate("mapbbox.map.title"),
    "NavigationControl.ResetBearing": translate("mapbbox.navigation-control.reset-bearing"),
    "NavigationControl.ZoomIn": translate("mapbbox.navigation-control.zoom-in"),
    "NavigationControl.ZoomOut": translate("mapbbox.navigation-control.zoom-out"),
    "ScrollZoomBlocker.CtrlMessage": translate("mapbbox.scroll-zoom-blocker.ctrl-message"),
    "ScrollZoomBlocker.CmdMessage": translate("mapbbox.scroll-zoom-blocker.cmd-message"),
    "TouchPanBlocker.Message": translate("mapbbox.touch-pan-blocker.message")
  }
}
